import MyInput from '../../components/ui/MyInput';
import deleteX from '../../assets/img/deleteX.svg';
import { useEffect, useState } from 'react';
import PrimaryButton from '../../components/ui/PrimaryButton';
import {
    SVG_Add_Square_Bold,
    SVG_Traffic_Bold,
    SVG_Trash_Bin_2_Bold,
    SVG_Trash_Bin_2_Linear,
    SVG_Trash_Bin_2_Outline,
    SVG_Trash_Bin_Minimalistic_2_Bold,
} from '@dev-mobligo/iconpack';
import { useDispatch } from 'react-redux';
import systemSlice from '../../redux/systemSlice';
import { useNavigate } from 'react-router-dom';
import allTabs from '../DashboardTabs';
import LayeredDashboardHeader from '../LayeredDashboardHeader';
import CreateAction from '../../components/operational/createAction';
import useCustomNavigate from '../../components/operational/goBack';
import { v4 as uuid } from 'uuid';
import { TreeSelect } from 'primereact/treeselect';
import store from '../../redux/store';
import { useSelector } from 'react-redux';
import countryCodes from '../../utils/countryCodes.json'
import { Dropdown } from 'primereact/dropdown';
import { translate } from '../../utils/language';

const countryOptions = countryCodes?.map(countryCode => { return { code: countryCode.iso2, name: countryCode.language, emoji: countryCode.emoji } })
const turkishCountryCode = countryOptions.find(countryOption => countryOption.code === "tr")
const DropdownItem = (item) => {
    return <div className=' p-1 text-sm flex flex-row gap-[5px]'>
        {item?.emoji}
        {"\t"}
        {item?.name}
    </div>
}
const AddLanguage = ({ tab, data, languages, setIsActive, getLanguageAndRegions, listCountry }) => {
    const navigate = useNavigate()
    const goBack = useCustomNavigate(tab)
    const [selectedNodeKeys, setSelectedNodeKeys] = useState(null);
    const [nodes, setNodes] = useState(null);
    const [languageOptions, setLanguageOptions] = useState(countryOptions)
    const [selectedLanguage, setSelectedLanguage] = useState(turkishCountryCode)
    const language = useSelector((state) => state.systemSlice.language)
    const dispatch = useDispatch()
    const addListCountry = async () => {
        const regions = Object.keys(selectedNodeKeys)?.filter(selectedNodeKey => !selectedNodeKey.includes("_region"))
        if (!(selectedNodeKeys && Object.keys(selectedNodeKeys)?.length > 0)) {
            return dispatch(systemSlice.actions.setToastError({ summary: translate("selectRegion") }))
        }
        const response = await CreateAction({
            method: data?.id ? "patch" : 'post',
            path: `/languageAndRegions`,
            showPreLoader: true,
            isFileUploading: false,
            data: {
                data: {
                    regions,
                    language: selectedLanguage?.code || "tr",
                    id: data?.id || uuid()
                }
            }
        });
        if (response?.error) {
            return
        }
        setIsActive(false)
        getLanguageAndRegions(listCountry)

    }

    const removeListCountry = async () => {

        const response = await CreateAction({
            method: 'delete',
            path: `/languageAndRegions`,
            showPreLoader: true,
            isFileUploading: false,
            data: {
                id: data?.id
            }
        });
        if (response?.error) {
            return
        }
        setIsActive(false)
        getLanguageAndRegions(listCountry)

    }

    useEffect(() => {
        const newLanguageOptions = countryOptions?.filter((countryOption) => !(languages?.includes(countryOption.code) && countryOption.code !== data?.language?.iso2))
        setLanguageOptions(newLanguageOptions)


        const newOptions = {}

        listCountry?.forEach((data, index) => {
            const region = data.region
            if (!newOptions[region]) {
                newOptions[region] = {
                    key: index + "_region",
                    label: region,
                    children: []
                }

            }
            newOptions[region].children.push(
                {
                    key: data.iso2,
                    label: data.emoji + " " + data.locationTranslations?.[language],
                    data
                }
            )

        })
        const newNodes = Object.values(newOptions)
        setNodes(newNodes)

        if (data) {
            const newSelectedNodeKeys = {}
            data?.regions?.forEach((region) => {
                newSelectedNodeKeys[region?.iso2] = {
                    checked: true,
                    partialChecked: false
                }
            })
            setSelectedNodeKeys(newSelectedNodeKeys)
            const newSelectedLanguage = newLanguageOptions.find(countryOption => countryOption.code === data?.language?.iso2)
            setSelectedLanguage(newSelectedLanguage || newLanguageOptions[0])
        } else {
            setSelectedLanguage(newLanguageOptions[0])

        }
    }, [])

    return (
        <>
            <LayeredDashboardHeader tab={tab} setIsActive={setIsActive}
                onSave={() => {
                    addListCountry()
                }}
                onDelete={data?.id && removeListCountry}
                onLeave={() => {
                    setIsActive(false)
                }}
            >
            </LayeredDashboardHeader>

            <div className='w-full h-[calc(100dvh-70px)] overflow-auto scrollbar-y-visible'>
                <div>
                    <div className="p-[20px] flex items-center justify-center 2xl:p-[40px] flex-col max-w-[1120px] mx-auto">
                        <div className="bg-white p-[20px] rounded-[10px] 2xl:p-[40px] max-w-[1120px] w-[100%]">
                            <div className='flex flex-col gap-[15px]'>

                                <div className='flex flex-col'>

                                    <div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <div className="text-[#5E5873] text-[18px] font-semibold"> Dil</div>

                                        </div>
                                    </div>
                                    {countryCodes &&
                                        <Dropdown
                                            filter
                                            value={selectedLanguage}
                                            className='w-full'
                                            itemTemplate={DropdownItem}
                                            options={languageOptions}
                                            optionLabel='name'
                                            onChange={(e) => {
                                                setSelectedLanguage(e.value)
                                            }}>

                                        </Dropdown>
                                    }
                                </div>
                                <div className='flex flex-col'>
                                    <div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <div className="text-[#5E5873] text-[18px] font-semibold"> Bölgeler</div>

                                        </div>
                                    </div>
                                    {nodes &&
                                        <TreeSelect showClear filter value={selectedNodeKeys} onChange={(e) => setSelectedNodeKeys(e.value)} options={nodes}
                                            metaKeySelection={false} className="md:w-20rem w-full" selectionMode="checkbox" display="chip" placeholder="Select Items"></TreeSelect>
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>

    );
};

export default AddLanguage;
